import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faCalendar } from "@fortawesome/free-solid-svg-icons"

export const Calendar = (props) => {
  return <FontAwesomeIcon faIcon={faCalendar} {...props} />
}
